module.exports = global.config = {
  isStorePage: false,
};
